import AppleIcon from "components/svgs/AppleIcon";
import CloseIcon from "components/svgs/CloseIcon";
import FacebookWhiteIcon from "components/svgs/FacebookWhiteIcon";
import GoogleIcon from "components/svgs/GoogleIcon";
import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCurrentUser } from "store/features/auth/authSlice";
import { Bounce, toast } from "react-toastify";

const LoginPopup = ({
  showLoginPopup,
  setShowLoginPopup,
  setShowSignupPopup,
}) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [user, setUser] = useState(null);

  const handleLogin = async () => {
    console.log("formData", formData);
    // toast.success("You have successfully logged in.");
  };

  const handleClosePopup = () => {
    setFormData({
      email: "",
      password: "",
    });
    setShowLoginPopup(false);
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          dispatch(setCurrentUser(res.data));
          const data = { ...res.data, provider: "google" };
          axios
            .post(`${process.env.REACT_APP_API_URL}/api/oauth2/success`, data)
            .then((res) => console.log("ressssss", res))
            .catch((err) => console.log("errrrrrrrrrr", err));
          handleClosePopup();
        })
        .catch((err) => console.log(err));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <Popup
      open={showLoginPopup}
      onClose={handleClosePopup}
      closeOnDocumentClick={false}
      className="auth-popup"
    >
      <div className="close-auth-popup" onClick={handleClosePopup}>
        <CloseIcon />
      </div>
      <div className="auth-popup-container">
        <div className="app-logo-container">
          <div className="app-logo">PAAH</div>
        </div>
        <div className="auth-to">Log in to Pan Armenian ArtHub</div>
        <div className="form-input">
          <div className="input-wrapper">
            <input
              type="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
          </div>
          <div className="input-wrapper">
            <input
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />
          </div>
          <div className="forgot-passowrd">Forgot Password?</div>
          <div className="auth-btn" onClick={handleLogin}>
            <button>Log in</button>
          </div>
        </div>
        <div className="or">OR</div>
        <div className="alternative-auth">
          <div className="withProvider">
            <FacebookWhiteIcon />
            Log in with Facebook
          </div>
          <div className="withProvider" onClick={() => loginWithGoogle()}>
            <GoogleIcon />
            Log in with Google
          </div>
          <div className="withProvider">
            <AppleIcon />
            Log in with Apple
          </div>
          <div className="no-account">
            Don't have an account?{" "}
            <span
              onClick={() => {
                handleClosePopup();
                setTimeout(() => {
                  setShowSignupPopup(true);
                }, 100);
              }}
            >
              SIGN UP
            </span>
          </div>
        </div>
        <div className="agreement">
          By clicking Log In or Continue with Email, Google, Apple or Facebook,
          you agree to PAAH's{" "}
          <a href="http://localhost:3000" target="_blank" rel="noreferrer">
            Terms and Conditions
          </a>{" "}
          and{" "}
          <a href="http://localhost:3000" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          .
        </div>
      </div>
    </Popup>
  );
};

export default LoginPopup;
